import { render, staticRenderFns } from "./TestGA.vue?vue&type=template&id=fb5b2d04"
import script from "./TestGA.vue?vue&type=script&lang=js"
export * from "./TestGA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports